import { KEYS } from "./schema.js";

const legacyNames = new Set([
  "Get up at 5.00",
  "Namaz until 6.00",
  "Sport until 7.00",
  "Self - Care until 8.00",
  "Eat until 8.30",
  "Math Olympiads until 10.30",
  "Reading (1 passage + Analyze) 1.5h",
  "Listening (Full Mock + Analyze) 1.15h",
  "Vocab review 0.15h",
  "Eat until 13.30",
  "Writing 1.5h",
  "Speaking 1h",
  "New Vocab 0.5h",
  "Free time - Sleep / GYM / Swim / Play until 19.00",
  "Eat until 19.30",
  "Startup until 22.00 2.5h",
  "Sleep until 22.30",
  "Eat until 9.00",
  "Full Mock until Launch",
  "Eat until 14.00",
  "Analyze Mock until 17.00",
  "Movie until 18.00",
  "Get up at 6.00",
  "SAT English until 10.00 2h",
  "SAT Math until 13.00 2.5h",
  "SAT Vocab + Review until 15.00 1.5h",
  "Math Olympiads until 17.00 2h",
  "Swim until 19.00",
  "Do everything you want until 19.00",
  "GYM until 19.00",
  "Eat until 20.00",
  "Startup until 22.00 2h",
  "Free time until 19.00",
  "Swimming until 19.00",
]);
const seededId =
  /^t_(?:Weekdays(?:_v2)?|Weekend|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)_\d+_/;

export function isSeededPlan(task) {
  return seededId.test(task.id) && legacyNames.has(task.name);
}

// Remove only unchanged tasks generated by older releases. User-created or
// renamed tasks keep their IDs, order, completion history, and study settings.
export function removeSeededPlans(values) {
  const templates = values[KEYS.templates];
  if (!templates) return values;
  const removed = new Set();
  const cleaned = Object.fromEntries(
    Object.entries(templates).map(([group, tasks]) => [
      group,
      tasks.filter((task) => {
        if (!isSeededPlan(task)) return true;
        removed.add(task.id);
        return false;
      }),
    ]),
  );
  if (!removed.size) return values;
  const next = { ...values, [KEYS.templates]: cleaned };
  if (values[KEYS.completions])
    next[KEYS.completions] = Object.fromEntries(
      Object.entries(values[KEYS.completions]).map(([date, checks]) => [
        date,
        Object.fromEntries(
          Object.entries(checks).filter(([id]) => !removed.has(id)),
        ),
      ]),
    );
  if (values[KEYS.prefs]?.studyFlow)
    next[KEYS.prefs] = {
      ...values[KEYS.prefs],
      studyFlow: Object.fromEntries(
        Object.entries(values[KEYS.prefs].studyFlow).map(
          ([group, settings]) => [
            group,
            Object.fromEntries(
              Object.entries(settings).filter(([id]) => !removed.has(id)),
            ),
          ],
        ),
      ),
    };
  return next;
}
